document.querySelectorAll('.collection-preview-swiper').forEach((swiperEl) => {
  const swiperId = swiperEl.id;
  const prevBtn = swiperEl.parentElement.querySelector(`[data-swiper="${swiperId}"].swiper-button-prev`);
  const nextBtn = swiperEl.parentElement.querySelector(`[data-swiper="${swiperId}"].swiper-button-next`);

  const swiper = new Swiper(`#${swiperId}`, {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 2.1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2.75,
      },
      992: {
        slidesPerView: 3.25,
      },
      1200: {
        slidesPerView: 3.75,
      },
      1600: {
        slidesPerView: 3.9,
      },
    },
  });
});

    var swiper = new Swiper(".imageSwiper", {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });